import { render, staticRenderFns } from "./AssetLink.vue?vue&type=template&id=3af340c4&scoped=true&"
import script from "./AssetLink.vue?vue&type=script&lang=js&"
export * from "./AssetLink.vue?vue&type=script&lang=js&"
import style0 from "./AssetLink.vue?vue&type=style&index=0&id=3af340c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af340c4",
  null
  
)

export default component.exports